import { isDark, mode, randomColor, multiStyleConfig } from "@chakra-ui/theme-tools";

function getSize(size) {
  var styles = {
    width: size,
    height: size
  };
  return {
    container: Object.assign({
      fontSize: "calc(" + size * 4 + "px / 2.5)"
    }, styles),
    excessLabel: styles,
    label: {
      fontSize: "calc(" + size * 4 + "px / 2.5)",
      fontWeight: "bold",
      lineHeight: size !== "100%" ? size * 4 + "px" : undefined,
      fontFamily: "heading",
      letterSpacing: "-1px"
    }
  };
}

var randomColors = ['teal.300', 'teal.200', 'orange.300', 'orange.200', 'red.300', 'red.200', 'ocean.300', 'ocean.200'];
var avatar = multiStyleConfig({
  parts: {
    container: "the avatar wrapper",
    excessLabel: "for avatar group, the excess avatar label",
    badge: "the top or bottom left badge",
    label: "the avatar's name initials text"
  },
  baseStyle: function baseStyle(props) {
    var name = props.name,
        theme = props.theme,
        autoTextContrast = props.autoTextContrast;
    var bg = name ? randomColor({
      string: name,
      colors: randomColors
    }) : "gray.400";
    var color = name && autoTextContrast ? isDark(props.bg || bg)(theme) ? "white" : "gray.800" : "white";
    var borderColor = mode("white", "gray.800")(props);
    return {
      badge: {
        transform: "translate(25%, 25%)",
        borderRadius: "full",
        border: "0.2em solid",
        borderColor: mode("white", "gray.800")(props)
      },
      excessLabel: {
        bg: mode("gray.200", "whiteAlpha.400")(props)
      },
      container: {
        bg: bg,
        color: color,
        borderColor: borderColor,
        verticalAlign: "top"
      }
    };
  },
  sizes: {
    "2xs": getSize("5"),
    xs: getSize("8"),
    sm: getSize("10"),
    md: getSize("16"),
    lg: getSize("24"),
    xl: getSize("32"),
    full: getSize("100%")
  },
  defaultProps: {
    size: "md",
    autoTextContrast: false
  }
});
export default avatar;